import { render, staticRenderFns } from "./ViewEmailModal.vue?vue&type=template&id=6dbbd600&"
import script from "./ViewEmailModal.vue?vue&type=script&lang=js&"
export * from "./ViewEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports